import * as types from '@store/types'
import axios from 'axios'
import decode from 'jwt-decode'
import accountActivateErrors from '@helpers/accountActivateErrors'
import getObjectByAttValue from '@helpers/getObjectByAttValue'

const state = {
  token: '',
  company: '',
  expiresAt: 0,
  company_name: '',
  credentials: { document: '', password: '', activate: undefined },
  generic_flag: false,
  check_document_alelo: '',
  token_alelo: ''
}

const getters = {
  [types.AUTH]: (state) => ({ ...state }),

  [types.AUTH_CREDENTIALS]: ({ credentials }) => {
    return { ...credentials }
  },

  [types.FLAG_GENERIC_APP]: (state) => {
    return state.generic_flag
  },

  [types.CHECK_DOCUMENT_ALELO]: ({ check_document_alelo }) => check_document_alelo
}

const mutations = {
  [types.AUTH]: (state, payload) => {
    state.token = payload && payload.token
    state.company = payload && payload.company
    state.company_name = payload && payload.company_name
    state.expiresAt = payload && ((payload.expiresAt || 0) + '').slice(0, 10) * 1000
  },

  [types.AUTH_CREDENTIALS]: (state, payload) => {
    state.credentials = { ...payload }
  },

  [types.FLAG_GENERIC_APP]: (state, payload) => {
    state.generic_flag = payload
  },

  [types.CHECK_DOCUMENT_ALELO]: (state, payload) => {
    state.check_document_alelo = payload
  },

  [types.TOKEN_ALELO]: (state, payload) => {
    state.token_alelo = payload
  }
}

const actions = {
  [types.AUTH_ACTIVATE]: async ({ state, commit, dispatch }, payload) => {
    if (!payload.confirm_password) payload.confirm_password = payload.password
    if (payload.categories) delete payload.categories
    const formData = new FormData()

    Object.keys(payload)
      .filter(key => (typeof payload[key] !== 'undefined') && (typeof payload[key] !== 'object' || !!payload[key]))
      .forEach(key => formData.append(key, payload[key]))
    payload.interests.forEach((interest, index) => {
      formData.append(`interests[${index}]`, interest)
    })
    formData.delete('interests')
    let endpoint = 'activate'
    if (!payload.password) endpoint = 'activate-authenticate'
    const { data: { ...data } } = await axios.post(endpoint, formData)
    const { company_slug: company, exp, document, name } = decode(data.token)
    await commit(types.AUTH, { token: data.token, company, expiresAt: exp })
    await dispatch(types.CONFIG, { name, document, exp })
    return data
  },

  [types.AUTH_ACTIVATE_ALELO]: async ({ state, commit, dispatch }, payload) => {
    try {
      const formData = new FormData()

      Object.keys(payload)
        .filter(key => (typeof payload[key] !== 'undefined') && (typeof payload[key] !== 'object' || !!payload[key]))
        .forEach(key => formData.append(key, payload[key]))

      const { data: { data: { token, ...data } } } = await axios.post(`company/invite/${state.token_alelo}`, formData)
      const { company_slug: company, exp, document, name } = decode(token)

      await commit(types.AUTH, { token, company, expiresAt: exp })
      await dispatch(types.CONFIG, { name, document, exp })

      return data
    } catch ({ response: { data: { data } } }) {
      return data
    }
  },

  [types.AUTH_ACTIVATE_CHECK]: async ({ commit }, payload) => {
    try {
      const { data } = await axios.post('activate/check', { ...payload })
      commit(types.AUTH_CREDENTIALS, payload)
      return data
    } catch ({ response: { data: { message } } }) {
      const activateError = getObjectByAttValue(accountActivateErrors, 'message', message)
      const error = activateError && activateError.length > 0 ? activateError[0].code : 404
      const errorObject = { error }

      return errorObject
    }
  },

  [types.AUTH_ACTIVATE_CHECK_ALELO]: async ({ commit }, document) => {
    try {
      const { data: { data } } = await axios.get(`user/check?document=${document}`)

      commit(types.CHECK_DOCUMENT_ALELO, data)
    } catch ({ response: { data: { message } } }) {
      if (message === 'User not found') { commit(types.CHECK_DOCUMENT_ALELO, false) }

      return message
    }
  },

  [types.AUTH_ACTIVATE_VERIFY]: async ({ dispatch, commit }, payload) => {
    try {
      const { data: { data } } = await axios.post('activate/verify', { ...payload })
      commit(types.AUTH_CREDENTIALS, { ...data, ...payload })
      return data
    } catch ({ response: { data: { message } } }) {
      const activateError = getObjectByAttValue(accountActivateErrors, 'message', message)
      const errorObject = { error: activateError[0].code }

      return errorObject
    }
  },

  [types.AUTH]: ({ commit, dispatch }, payload) => {
    const { token, company } = payload || {}
    if (!token || !company) return

    const { exp, document, name, company_name } = decode(token)
    commit(types.AUTH, { token, company, expiresAt: exp, company_name })
    dispatch(types.CONFIG, { name, document, exp, company_name })
  },

  [types.AUTH_LOGIN_GENERIC_APP]: async ({ commit, dispatch }, payload) => {
    try {
      const { data: { data } } = await axios.post('login', { ...payload })

      if (typeof data === 'string') {
        const token = data.match(/(?:token=)(.*)(?=&company)/)[0]

        const { company_slug: company, exp, document, name, company_name } = decode(token)

        commit(types.AUTH, { company, expiresAt: exp, company_name })

        dispatch(types.CONFIG, { name, document, exp, company_name })

        window.location.replace(data)

        return { token }
      }

      return data
    } catch ({ response: { data: { data: { error } } } }) {
      return error
    }
  },

  [types.AUTH_LOGIN]: async ({ commit, dispatch }, payload) => {
    try {
      const { data } = await axios.post('login', { ...payload })
      if (data.activate) return { activate: true, data: data.data }
      const { company_slug: company, exp, document, name, company_name } = decode(data.data.token)

      commit(types.AUTH, { token: data.data.token, company, expiresAt: exp, company_name })

      dispatch(types.CONFIG, { name, document, exp, company_name })

      return { token: data.data.token }
    } catch ({ response: { data: { data } } }) {
      return { data }
    }
  },

  [types.AUTH_REQUEST_RESET]: async ({ commit }, { ...payload }) => {
    try {
      const { data: { data } } = await axios.post('company/user/remember', payload)
      return data
    } catch ({ response: { data: { data } } }) {
      return data
    }
  },

  [types.AUTH_RESET_PASSWORD]: async ({ commit, dispatch }, { token, ...payload }) => {
    try {
      const { data } = await axios.post(`company/user/remember/${token}`, payload)
      return data
    } catch (err) {
      const text = 'Não foi possível alterar sua senha'
      dispatch(types.FEEDBACK, { type: 'error', text })
      return false
    }
  },

  [types.AUTH_LOGOUT]: async ({ state, commit, getters }) => {
    const config = getters[types.CONFIG_MAIN]

    await commit(types.AUTH, {
      token: null,
      company: null
    })

    if (state.generic_flag) {
      window.location.href = process.env.GENERIC_LOGOUT_URL + '/entrar?logout=true'
    } else if (config.has_api_access &&
      config.has_restrict_access &&
      !config.logout_url &&
      !state.generic_flag
    ) {
      window.location.href = config.url
    } else if (config.has_api_access &&
      config.has_restrict_access &&
      config.logout_url &&
      !state.generic_flag
    ) {
      window.location.href = config.logout_url
    } else {
      window.location.href = window.location.reload()
    }

    await commit(types.FLAG_GENERIC_APP, false)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/auth.js